function CourseMarker({ cluster, onClick }) {
  const { name } = cluster.properties

  return <div className="marker" onClick={onClick} title={name} />
}

export default CourseMarker
